import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { GuidService } from 'ui-components/services/guid-service';

import { ReturnDetailsModalContainer } from './return-details-modal-container';

import { openReturnDetailModal, closedReturnDetailModal } from '../../../store/returns/details/returns.details.actions';
import { setSelectedReturns } from '../../../store/returns/selected-returns/returns.selected-returns.actions';

export const ReturnModalLoader = () => {
  const { fulfillmentId } = useParams();
  const dispatch = useDispatch();
  const returnDetailModalId = useMemo(() => GuidService.newGuid(), []);
  const onClose = useCallback(() => {
    dispatch(closedReturnDetailModal(returnDetailModalId));
  }, [dispatch, returnDetailModalId]);

  const loadDetails = useCallback((...args) => dispatch(openReturnDetailModal(...args)), [dispatch]);
  const setSelectedReturnsCb = useCallback((selectedReturnIds) => dispatch(setSelectedReturns(selectedReturnIds)), [dispatch]);

  return (
    <ReturnDetailsModalContainer
      fulfillmentId={fulfillmentId}
      loadDetails={loadDetails}
      onClose={onClose}
      returnDetailModalId={returnDetailModalId}
      setSelectedReturns={setSelectedReturnsCb}
    />
  );
};
